import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../config.js";
import r from "../../request.js";
import { throwIfAborted as s } from "../../core/promiseUtils.js";
import { removeTrailingSlash as t, getOrigin as o, isProtocolRelative as l, isAbsolute as i, join as n, normalize as u, removeFile as c, appBaseUrl as a, addQueryParameters as f } from "../../core/urlUtils.js";
import p from "../../views/2d/engine/vectorTiles/style/VectorTileSource.js";
var m = e.defaults && e.defaults.io.corsEnabledServers;

function y(_x, _x2) {
  return _y.apply(this, arguments);
}

function _y() {
  _y = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, r) {
    var s, _ref, _ref2, t, o, l;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            s = {
              source: null,
              sourceBase: null,
              sourceUrl: null,
              validatedSource: null,
              style: null,
              styleBase: null,
              styleUrl: null,
              sourceNameToSource: {},
              primarySourceName: "",
              spriteFormat: "png"
            }, _ref = "string" == typeof e ? [e, null] : [null, e.jsonUrl], _ref2 = _slicedToArray(_ref, 2), t = _ref2[0], o = _ref2[1];
            _context.next = 3;
            return h(s, "esri", e, o, r);

          case 3:
            l = {
              layerDefinition: s.validatedSource,
              url: t,
              serviceUrl: s.sourceUrl,
              style: s.style,
              styleUrl: s.styleUrl,
              spriteUrl: s.style.sprite && S(s.styleBase, s.style.sprite),
              spriteFormat: s.spriteFormat,
              glyphsUrl: s.style.glyphs && S(s.styleBase, s.style.glyphs),
              sourceNameToSource: s.sourceNameToSource,
              primarySourceName: s.primarySourceName
            };
            return _context.abrupt("return", (d(l.spriteUrl), d(l.glyphsUrl), l));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _y.apply(this, arguments);
}

function d(e) {
  if (!e) return;
  var r = o(e);
  m && !m.includes(r) && m.push(r);
}

function S() {
  var r;

  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }

  for (var _s = 0; _s < e.length; ++_s) {
    if (l(e[_s])) {
      if (r) {
        var _t = r.split("://")[0];
        r = _t + ":" + e[_s].trim();
      }
    } else r = i(e[_s]) ? e[_s] : n(r, e[_s]);
  }

  return t(r);
}

function h(_x3, _x4, _x5, _x6, _x7) {
  return _h.apply(this, arguments);
}

function _h() {
  _h = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t, o, l, i) {
    var n, c, a, _e, f;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(s(i), "string" == typeof o)) {
              _context2.next = 11;
              break;
            }

            _e = u(o);
            d(_e);
            _context2.next = 5;
            return r(_e, _objectSpread(_objectSpread({}, i), {}, {
              responseType: "json",
              query: _objectSpread({
                f: "json"
              }, null == i ? void 0 : i.query)
            }));

          case 5:
            a = _context2.sent;
            a.ssl && (n && (n = n.replace(/^http:/i, "https:")), c && (c = c.replace(/^http:/i, "https:")));
            n = _e;
            c = _e;
            _context2.next = 12;
            break;

          case 11:
            a = {
              data: o
            }, n = o.jsonUrl || null, c = l;

          case 12:
            f = a.data;
            return _context2.abrupt("return", U(f) ? (e.styleUrl = n || null, v(e, f, c, i)) : x(f) ? e.sourceUrl ? w(e, f, c, !1, t, i) : (e.sourceUrl = n || null, w(e, f, c, !0, t, i)) : Promise.reject("You must specify the URL or the JSON for a service or for a style."));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _h.apply(this, arguments);
}

function U(e) {
  return !!e.sources;
}

function x(e) {
  return !U(e);
}

function v(_x8, _x9, _x10, _x11) {
  return _v.apply(this, arguments);
}

function _v() {
  _v = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, r, s, t) {
    var o, l, _s2, _i, _Object$keys, _i2;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            o = s ? c(s) : a;
            e.styleBase = o, e.style = r, e.styleUrl && d(e.styleUrl), r["sprite-format"] && "webp" === r["sprite-format"].toLowerCase() && (e.spriteFormat = "webp");
            l = [];

            if (!(r.sources && r.sources.esri)) {
              _context3.next = 11;
              break;
            }

            _s2 = r.sources.esri;

            if (!_s2.url) {
              _context3.next = 10;
              break;
            }

            _context3.next = 8;
            return h(e, "esri", S(o, _s2.url), void 0, t);

          case 8:
            _context3.next = 11;
            break;

          case 10:
            l.push(h(e, "esri", _s2, o, t));

          case 11:
            for (_i = 0, _Object$keys = Object.keys(r.sources); _i < _Object$keys.length; _i++) {
              _i2 = _Object$keys[_i];
              "esri" !== _i2 && "vector" === r.sources[_i2].type && (r.sources[_i2].url ? l.push(h(e, _i2, S(o, r.sources[_i2].url), void 0, t)) : r.sources[_i2].tiles && l.push(h(e, _i2, r.sources[_i2], o, t)));
            }

            _context3.next = 14;
            return Promise.all(l);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _v.apply(this, arguments);
}

function w(_x12, _x13, _x14, _x15, _x16, _x17) {
  return _w.apply(this, arguments);
}

function _w() {
  _w = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, r, s, o, l, i) {
    var n, u, c, _r;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            n = s ? t(s) + "/" : a, u = g(r, n), c = new p(l, f(n, null == i ? void 0 : i.query), u);

            if (!(!o && e.primarySourceName in e.sourceNameToSource)) {
              _context4.next = 6;
              break;
            }

            _r = e.sourceNameToSource[e.primarySourceName];

            if (_r.isCompatibleWith(c)) {
              _context4.next = 5;
              break;
            }

            return _context4.abrupt("return", Promise.resolve());

          case 5:
            null != c.fullExtent && (null != _r.fullExtent ? _r.fullExtent.union(c.fullExtent) : _r.fullExtent = c.fullExtent.clone()), _r.tileInfo.lods.length < c.tileInfo.lods.length && (_r.tileInfo = c.tileInfo);

          case 6:
            if (!(o ? (e.sourceBase = n, e.source = r, e.validatedSource = u, e.primarySourceName = l, e.sourceUrl && d(e.sourceUrl)) : d(n), e.sourceNameToSource[l] = c, !e.style)) {
              _context4.next = 8;
              break;
            }

            return _context4.abrupt("return", null == r.defaultStyles ? Promise.reject() : "string" == typeof r.defaultStyles ? h(e, "", S(n, r.defaultStyles, "root.json"), void 0, i) : h(e, "", r.defaultStyles, S(n, "root.json"), i));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _w.apply(this, arguments);
}

function g(e, r) {
  if (e.hasOwnProperty("tileInfo")) return e;
  var s = {
    xmin: -20037507.067161843,
    ymin: -20037507.067161843,
    xmax: 20037507.067161843,
    ymax: 20037507.067161843,
    spatialReference: {
      wkid: 102100
    }
  },
      t = 512;
  var o = 78271.51696400007,
      l = 295828763.7957775;
  var i = [],
      n = e.hasOwnProperty("minzoom") ? +e.minzoom : 0,
      u = e.hasOwnProperty("maxzoom") ? +e.maxzoom : 22;

  for (var _c = 0; _c <= u; _c++) {
    _c >= n && i.push({
      level: _c,
      scale: l,
      resolution: o
    }), o /= 2, l /= 2;
  }

  var _iterator = _createForOfIteratorHelper(e.tiles),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _c2 = _step.value;
      d(S(r, _c2));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return {
    capabilities: "TilesOnly",
    initialExtent: s,
    fullExtent: s,
    minScale: 0,
    maxScale: 0,
    tiles: e.tiles,
    tileInfo: {
      rows: t,
      cols: t,
      dpi: 96,
      format: "pbf",
      origin: {
        x: -20037508.342787,
        y: 20037508.342787
      },
      lods: i,
      spatialReference: {
        wkid: 102100
      }
    }
  };
}

export { y as loadMetadata };